import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { store } from "../../redux/oldStore";
import {
  ParticipantRequirement,
  RequirementInputType,
  UiFormData,
} from "../../utils/CommonTypes/UserTypes";
import { Server, ServerResponse } from "../../utils/Server";
import { IState, ReduxMap } from "../../redux/redux";
import Icon, { IconType } from "../../Components/Icon/Icon";
import NhdMedicalForm from "../../Components/User/NhdMedicalForm";
import RegistrationStepper from "../../Components/RegistrationStepper/RegistrationStepper";

interface IProps extends IState {

}

const MedicalPage = (props: IProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const {userId} = useParams();
  const [formData, setFormData] = useState<UiFormData>();
  const [requirements, setRequirements] = useState<ParticipantRequirement[]>(
    []
  );
  const [formValues, setFormValues] = useState<Record<string, string>>({});
  const [requiredMissing, setRequiredMissing] = useState(false);

  useEffect(() => {
    
  }, []);

  useEffect(() => {
    if(formData?.Requirements && formData.Requirements.length > 0){
      return;
    }
    if (formData && formData.NewRecord && formData.NextRecordPath) {
      navigate(`${formData?.NextRecordPath}/${window.location.search}`);
    }
  }, [requirements, formData]);



  return (
    <div className="user-requirements-container">
        {userId && <RegistrationStepper personId={userId} currentStep="medical" />}
        {userId && <NhdMedicalForm
         canSave={true}
         isFristTimeLogin={true}
         isNewUser={true}
         recordExists={false}
         personId={userId}
         onContinue={async ()=>{
            const res = await store.server.postApi<ServerResponse<{ NextRecordPath?: string }>>('../UserProfile/MarkRegistrationStepCompleted', { userId: userId, step: 'medical' });
            if (!res.Success) {
              toast.error(res.Message || 'Unable to continue.', { autoClose: false });
              return;
            }
            const next = res.Value?.NextRecordPath || `/app/store/${userId}`;
            navigate(`${next}${location.search}`);
         }}
        />}
    </div>
  );
};

export default ReduxMap(MedicalPage);
